// import React from "react";
// import {
//   Card,
//   CardContent,
//   Stack,
//   Typography,
//   Button,
//   Divider,
//   Alert,
//   Grid,
//   Chip,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   TextField,
//   FormControlLabel,
//   Switch,
// } from "@mui/material";

// const EmailSmtpTab = ({ smtpConfig, onEdit }) => {
//   return (
//     <Card variant="outlined" sx={{ borderRadius: 3 }}>
//       <CardContent>
//         <Stack
//           direction={{ xs: "column", md: "row" }}
//           justifyContent="space-between"
//           spacing={2}
//           alignItems={{ xs: "flex-start", md: "center" }}
//         >
//           <div>
//             <Typography variant="h6">Client SMTP Configuration</Typography>
//             <Typography variant="body2" color="text.secondary">
//               If active, this SMTP will be used before platform SMTP.
//             </Typography>
//           </div>
//           <Button variant="contained" onClick={onEdit}>
//             {smtpConfig ? "Edit SMTP" : "Add SMTP"}
//           </Button>
//         </Stack>

//         <Divider sx={{ my: 2 }} />

//         {!smtpConfig ? (
//           <Alert severity="info">
//             No client SMTP configured. Platform SMTP will be used.
//           </Alert>
//         ) : (
//           <Grid container spacing={2}>
//             <Grid item xs={12} md={4}>
//               <Typography variant="subtitle2">SMTP Host</Typography>
//               <Typography variant="body2">{smtpConfig.smtp_host}</Typography>
//             </Grid>
//             <Grid item xs={12} md={2}>
//               <Typography variant="subtitle2">Port</Typography>
//               <Typography variant="body2">{smtpConfig.smtp_port}</Typography>
//             </Grid>
//             <Grid item xs={12} md={3}>
//               <Typography variant="subtitle2">User</Typography>
//               <Typography variant="body2">{smtpConfig.smtp_user}</Typography>
//             </Grid>
//             <Grid item xs={12} md={3}>
//               <Typography variant="subtitle2">From Email</Typography>
//               <Typography variant="body2">{smtpConfig.from_email}</Typography>
//             </Grid>
//             <Grid item xs={12} md={2}>
//               <Chip
//                 size="small"
//                 label={smtpConfig.is_active ? "Active" : "Inactive"}
//                 color={smtpConfig.is_active ? "success" : "default"}
//               />
//             </Grid>
//             <Grid item xs={12} md={2}>
//               <Chip
//                 size="small"
//                 label={`TLS: ${smtpConfig.use_tls ? "Yes" : "No"}`}
//                 variant="outlined"
//               />
//             </Grid>
//             <Grid item xs={12} md={2}>
//               <Chip
//                 size="small"
//                 label={`SSL: ${smtpConfig.use_ssl ? "Yes" : "No"}`}
//                 variant="outlined"
//               />
//             </Grid>
//           </Grid>
//         )}
//       </CardContent>
//     </Card>
//   );
// };

// const DialogComponent = ({
//   open,
//   onClose,
//   smtpConfig,
//   smtpForm,
//   setSmtpForm,
//   onSave,
//   onDelete,
// }) => {
//   return (
//     <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
//       <DialogTitle>{smtpConfig ? "Edit SMTP Config" : "Add SMTP Config"}</DialogTitle>
//       <DialogContent dividers>
//         <Grid container spacing={2}>
//           <Grid item xs={12} md={6}>
//             <TextField
//               fullWidth
//               label="SMTP Host"
//               value={smtpForm.smtp_host}
//               onChange={(e) =>
//                 setSmtpForm((prev) => ({ ...prev, smtp_host: e.target.value }))
//               }
//             />
//           </Grid>

//           <Grid item xs={12} md={3}>
//             <TextField
//               fullWidth
//               type="number"
//               label="SMTP Port"
//               value={smtpForm.smtp_port}
//               onChange={(e) =>
//                 setSmtpForm((prev) => ({ ...prev, smtp_port: Number(e.target.value) }))
//               }
//             />
//           </Grid>

//           <Grid item xs={12} md={3}>
//             <TextField
//               fullWidth
//               label="From Email"
//               value={smtpForm.from_email}
//               onChange={(e) =>
//                 setSmtpForm((prev) => ({ ...prev, from_email: e.target.value }))
//               }
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               fullWidth
//               label="SMTP Username"
//               value={smtpForm.smtp_user}
//               onChange={(e) =>
//                 setSmtpForm((prev) => ({ ...prev, smtp_user: e.target.value }))
//               }
//             />
//           </Grid>

//           <Grid item xs={12} md={6}>
//             <TextField
//               fullWidth
//               type="password"
//               label={smtpConfig ? "SMTP Password (leave blank to keep same)" : "SMTP Password"}
//               value={smtpForm.smtp_password}
//               onChange={(e) =>
//                 setSmtpForm((prev) => ({ ...prev, smtp_password: e.target.value }))
//               }
//             />
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <FormControlLabel
//               control={
//                 <Switch
//                   checked={smtpForm.use_tls}
//                   onChange={(e) =>
//                     setSmtpForm((prev) => ({
//                       ...prev,
//                       use_tls: e.target.checked,
//                       use_ssl: e.target.checked ? false : prev.use_ssl,
//                     }))
//                   }
//                 />
//               }
//               label="Use TLS"
//             />
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <FormControlLabel
//               control={
//                 <Switch
//                   checked={smtpForm.use_ssl}
//                   onChange={(e) =>
//                     setSmtpForm((prev) => ({
//                       ...prev,
//                       use_ssl: e.target.checked,
//                       use_tls: e.target.checked ? false : prev.use_tls,
//                     }))
//                   }
//                 />
//               }
//               label="Use SSL"
//             />
//           </Grid>

//           <Grid item xs={12} md={4}>
//             <FormControlLabel
//               control={
//                 <Switch
//                   checked={smtpForm.is_active}
//                   onChange={(e) =>
//                     setSmtpForm((prev) => ({ ...prev, is_active: e.target.checked }))
//                   }
//                 />
//               }
//               label="Active"
//             />
//           </Grid>
//         </Grid>
//       </DialogContent>

//       <DialogActions>
//         {smtpConfig && (
//           <Button color="error" onClick={onDelete}>
//             Delete
//           </Button>
//         )}
//         <Button onClick={onClose}>Cancel</Button>
//         <Button variant="contained" onClick={onSave}>
//           Save SMTP
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// EmailSmtpTab.DialogComponent = DialogComponent;

// export default EmailSmtpTab;


import React from "react";
import {
  Card, CardContent, Stack, Typography, Button, Divider, Alert, Grid, Chip, Paper, Box,
  Dialog, DialogTitle, DialogContent, DialogActions, TextField, FormControlLabel, Switch
} from "@mui/material";
import DnsOutlinedIcon from "@mui/icons-material/DnsOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import AlternateEmailOutlinedIcon from "@mui/icons-material/AlternateEmailOutlined";

const accent = "#0d47a1";
const accentLight = "#e3f2fd";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "10px", backgroundColor: "#f8f9fb",
    "&:hover": { backgroundColor: "#f0f2f5" },
    "&.Mui-focused": { backgroundColor: "#fff", "& .MuiOutlinedInput-notchedOutline": { borderColor: accent, borderWidth: 2 } }
  },
  "& .MuiInputLabel-root.Mui-focused": { color: accent }
};

const InfoRow = ({ label, value, icon }) => (
  <Stack direction="row" alignItems="center" spacing={2} sx={{ py: 1.5, px: 2, borderRadius: 2, "&:hover": { backgroundColor: "#f8faff" } }}>
    {icon}
    <Box sx={{ flex: 1 }}>
      <Typography variant="caption" color="text.secondary" fontWeight={500}>{label}</Typography>
      <Typography variant="body2" fontWeight={600}>{value}</Typography>
    </Box>
  </Stack>
);

const EmailSmtpTab = ({ smtpConfig, onEdit }) => {
  return (
    <Paper elevation={0} sx={{ borderRadius: 3, border: "1px solid #e3e8f0", overflow: "hidden" }}>
      <Box sx={{ p: 3, background: `linear-gradient(135deg, ${accent}, #1565c0)`, color: "#fff" }}>
        <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} spacing={2}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <DnsOutlinedIcon />
            <Box>
              <Typography variant="h6" fontWeight={700}>SMTP Configuration</Typography>
              <Typography variant="body2" sx={{ opacity: 0.85 }}>Custom SMTP overrides the platform default</Typography>
            </Box>
          </Stack>
          <Button variant="contained" startIcon={smtpConfig ? <EditOutlinedIcon /> : <AddCircleOutlineIcon />} onClick={onEdit}
            sx={{ backgroundColor: "#fff", color: accent, fontWeight: 600, "&:hover": { backgroundColor: accentLight } }}>
            {smtpConfig ? "Edit SMTP" : "Add SMTP"}
          </Button>
        </Stack>
      </Box>

      <Box sx={{ p: 3 }}>
        {!smtpConfig ? (
          <Alert severity="info" icon={<DnsOutlinedIcon />} sx={{ borderRadius: 2 }}>
            No custom SMTP configured. The platform SMTP will be used for all emails.
          </Alert>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <InfoRow label="SMTP Host" value={smtpConfig.smtp_host} icon={<DnsOutlinedIcon sx={{ color: accent, fontSize: 20 }} />} />
              <InfoRow label="Port" value={smtpConfig.smtp_port} icon={<SecurityOutlinedIcon sx={{ color: accent, fontSize: 20 }} />} />
              <InfoRow label="User" value={smtpConfig.smtp_user} icon={<AlternateEmailOutlinedIcon sx={{ color: accent, fontSize: 20 }} />} />
            </Grid>
            <Grid item xs={12} md={6}>
              <InfoRow label="From Email" value={smtpConfig.from_email} icon={<AlternateEmailOutlinedIcon sx={{ color: accent, fontSize: 20 }} />} />
              <Stack direction="row" spacing={1.5} sx={{ p: 2 }}>
                <Chip size="small" icon={smtpConfig.use_tls ? <CheckCircleOutlinedIcon /> : <CancelOutlinedIcon />} label="TLS"
                  sx={{ fontWeight: 600, backgroundColor: smtpConfig.use_tls ? "#e8f5e9" : "#f5f5f5", color: smtpConfig.use_tls ? "#2e7d32" : "#999" }} />
                <Chip size="small" icon={smtpConfig.use_ssl ? <CheckCircleOutlinedIcon /> : <CancelOutlinedIcon />} label="SSL"
                  sx={{ fontWeight: 600, backgroundColor: smtpConfig.use_ssl ? "#e8f5e9" : "#f5f5f5", color: smtpConfig.use_ssl ? "#2e7d32" : "#999" }} />
                <Chip size="small" icon={smtpConfig.is_active ? <CheckCircleOutlinedIcon /> : <CancelOutlinedIcon />} label="Active"
                  sx={{ fontWeight: 600, backgroundColor: smtpConfig.is_active ? "#e8f5e9" : "#fff3e0", color: smtpConfig.is_active ? "#2e7d32" : "#e65100" }} />
              </Stack>
            </Grid>
          </Grid>
        )}
      </Box>
    </Paper>
  );
};

const DialogComponent = ({ open, onClose, smtpConfig, smtpForm, setSmtpForm, onSave, onDelete }) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm" PaperProps={{ sx: { borderRadius: 3 } }}>
      <DialogTitle sx={{ background: `linear-gradient(135deg, ${accent}, #1565c0)`, color: "#fff", fontWeight: 700 }}>
        {smtpConfig ? "Edit SMTP Config" : "Add SMTP Config"}
      </DialogTitle>
      <DialogContent sx={{ pt: "24px !important" }}>
        <Stack spacing={2.5}>
          <TextField fullWidth label="SMTP Host" value={smtpForm.smtp_host} onChange={(e) => setSmtpForm((p) => ({ ...p, smtp_host: e.target.value }))} sx={inputSx} />
          <Stack direction="row" spacing={2}>
            <TextField fullWidth label="Port" type="number" value={smtpForm.smtp_port} onChange={(e) => setSmtpForm((p) => ({ ...p, smtp_port: Number(e.target.value) }))} sx={inputSx} />
            <TextField fullWidth label="From Email" value={smtpForm.from_email} onChange={(e) => setSmtpForm((p) => ({ ...p, from_email: e.target.value }))} sx={inputSx} />
          </Stack>
          <TextField fullWidth label="SMTP User" value={smtpForm.smtp_user} onChange={(e) => setSmtpForm((p) => ({ ...p, smtp_user: e.target.value }))} sx={inputSx} />
          <TextField fullWidth label="SMTP Password" type="password" placeholder={smtpConfig ? "Leave blank to keep existing" : ""} value={smtpForm.smtp_password} onChange={(e) => setSmtpForm((p) => ({ ...p, smtp_password: e.target.value }))} sx={inputSx} />
          <Stack direction="row" spacing={2}>
            <FormControlLabel control={<Switch checked={smtpForm.use_tls} onChange={(e) => setSmtpForm((p) => ({ ...p, use_tls: e.target.checked, use_ssl: e.target.checked ? false : p.use_ssl }))} sx={{ "& .Mui-checked": { color: accent } }} />} label="Use TLS" />
            <FormControlLabel control={<Switch checked={smtpForm.use_ssl} onChange={(e) => setSmtpForm((p) => ({ ...p, use_ssl: e.target.checked, use_tls: e.target.checked ? false : p.use_tls }))} sx={{ "& .Mui-checked": { color: accent } }} />} label="Use SSL" />
            <FormControlLabel control={<Switch checked={smtpForm.is_active} onChange={(e) => setSmtpForm((p) => ({ ...p, is_active: e.target.checked }))} sx={{ "& .Mui-checked": { color: accent } }} />} label="Active" />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        {smtpConfig && <Button color="error" onClick={onDelete} sx={{ mr: "auto" }}>Delete</Button>}
        <Button onClick={onClose} sx={{ color: "#666" }}>Cancel</Button>
        <Button variant="contained" onClick={onSave} sx={{ background: `linear-gradient(135deg, ${accent}, #1565c0)`, borderRadius: 2, px: 3, fontWeight: 600 }}>Save SMTP</Button>
      </DialogActions>
    </Dialog>
  );
};

EmailSmtpTab.DialogComponent = DialogComponent;
export default EmailSmtpTab;
